import ReportAccordionItem from "./ReportAccordionItem";


/**
 * Component that renders a list of test reports inside accordion items.
 */
const ReportAccordionList = ({ filteredReports, navigate, onStatusChange, isReviewer }) => {
  return (
    <div className="ids-mt-6">
      {filteredReports.map((report) => (
        <ReportAccordionItem
          key={report.id ?? `${report.date}-${report.selectedContract}`}
          report={report}
          navigate={navigate}
          onStatusChange={onStatusChange}
          isReviewer={isReviewer}
        />
      ))}
    </div>
  );
};

export default ReportAccordionList;